import { Image } from '@vinted/web-ui'

import { NewAgainPotentialSectionCardModel } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

const NewAgainPotentialCard = ({
  title,
  image,
  index,
}: NewAgainPotentialSectionCardModel & { index: number }) => (
  <article className="new-again__potential-card" data-testid="new-again__potential-card">
    <div className="new-again__potential-card-image">
      <Image src={image} scaling={Image.Scaling.Fill} testId={`new-again-card-image-${index}`} />
    </div>
    <h3 className="new-again__potential-card-title">{title}</h3>
  </article>
)

export default NewAgainPotentialCard
